import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
            navigate('/', { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post('/auth/session', { session_id: sessionId });
                setUser(data.user);
                const target = data.user?.role === 'admin' ? '/admin' : '/mon-compte';
                navigate(target, { replace: true, state: { user: data.user } });
            } catch {
                navigate('/', { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#050505]">
            <div className="text-[#C5A059] uppercase tracking-[0.3em] text-xs">Connexion...</div>
        </div>
    );
}
